import React, { useState } from "react"
import { Box, Image, HStack } from "@chakra-ui/react"

type Image = {
  src: string
  alt: string
}

interface Props {
  images: Image[]
}

export const ProductImages = (props: Props) => {
  const { images } = props
  const [mainImage, setMainImage] = useState(images[0])

  return (
    <>
      <Box>
        <Box width="100%">
          <Image
            src={mainImage.src}
            boxSize="full"
            alt={mainImage.alt}
            backgroundSize="cover"
          />
        </Box>

        <HStack spacing="8px" mt={2} mb={2}>
          {images.map(image => {
            return (
              <Box
                width="70px"
                height="70px"
                onClick={() => setMainImage(image)}
              >
                <Image
                  src={image.src}
                  boxSize="full"
                  alt="Nyame nti"
                  backgroundSize="cover"
                />
              </Box>
            )
          })}
        </HStack>
      </Box>
    </>
  )
}
